import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import serviceUsers from '@/service/ServiceUsers';
import { getToken, setToken, removeToken } from '@tencent/s2-client-vue-lib';
import router, { resetRouter } from '@/router';
import { permissionModule } from './ModulePermission';
import { tagsViewModule } from './ModuleTagsView';
import store from '@/store';

/** document hooks */
export interface IUserState {
	token: string;
	name: string;
	avatar: string;
	introduction: string;
	roles: string[];
	email: string;
}

/** 工作流数据结构 */
export interface IWorkflowData {
	jumpUrl: string;
	imgUrl: string;
	moduleCode: string;
	moduleName: string;
	todoNum: number;
}

/** document hooks */
@Module({
	dynamic: true,
	store,
	name: 'user'
})
class User extends VuexModule implements IUserState {
	public token: any = getToken() || '';
	public name: any = '';
	public avatar: any = '';
	public introduction: any = '';
	public roles: string[] = [];
	public email: any = '';

	/**
	 * 当前用户数据
	 *
	 * @type {IUserData}
	 * @memberOf User
	 */
	public userData: IUserData = {
		nickName: ''
	};

	/**
	 * action set user data
	 *
	 * @param {IUserData} userData
	 *
	 * @memberOf User
	 */
	@Action
	public setUserData(userData: IUserData): void {
		this.SET_USER_DATA(userData);
	}

	/**
	 * mutation set user data
	 *
	 * @private
	 * @param {IUserData} userData
	 *
	 * @memberOf User
	 */
	@Mutation
	private SET_USER_DATA(userData: IUserData): void {
		this.userData = userData;
	}

	/** document hooks */
	@Mutation
	private SET_TOKEN(token: string): any {
		this.token = token;
	}

	/** document hooks */
	@Mutation
	private SET_NAME(name: string): any {
		this.name = name;
	}

	/** document hooks */
	@Mutation
	private SET_AVATAR(avatar: string): any {
		this.avatar = avatar;
	}

	/** document hooks */
	@Mutation
	private SET_INTRODUCTION(introduction: string): any {
		this.introduction = introduction;
	}

	/** document hooks */
	@Mutation
	private SET_ROLES(roles: string[]): any {
		this.roles = roles;
	}

	/** document hooks */
	@Mutation
	private SET_EMAIL(email: string): any {
		this.email = email;
	}

	/** document hooks */
	@Action
	public async login(userInfo: { username: string; password: string }): Promise<any> {
		// console.log('Login..');
		// const { username, password }: any = userInfo;
		// let usernameVal: any = username;
		// usernameVal = username.trim();
		// const responseData: any = await serviceUsers.login({
		// 	username: usernameVal,
		// 	password
		// });
		// const { data }: any = { data: { accessToken: 'admin-token' } };
		// console.log('save user..');
		// setToken(data.accessToken);
		// this.SET_TOKEN(data.accessToken);
	}

	/** document hooks */
	@Action
	public resetToken(): any {
		removeToken();
		// this.SET_TOKEN('');
		this.SET_ROLES([]);
	}

	/** document hooks */
	@Action
	public async getUserInfo(): Promise<any> {
		// console.log('Get user info...');

		if (this.token === '') {
			throw Error('getUserInfo: token is undefined!');
		}

		// const { data }: any = await serviceUsers.getUserInfo({
		// 	/* Your params here */
		// });
		const { data }: any = {
			data: {
				user: {
					id: 0,
					username: 'admin',
					password: 'any',
					name: 'Super Admin',
					avatar: '',
					introduction: 'I am a super administrator',
					email: 'admin@test.com',
					phone: '1234567890',
					roles: ['admin']
				}
			}
		};

		if (!data) {
			throw Error('Verification failed, please Login again.');
		}

		const { roles, name, avatar, introduction, email }: any = data.user;
		// roles must be a non-empty array

		if (!roles || roles.length <= 0) {
			throw Error('getUserInfo: roles must be a non-null array!');
		}

		this.SET_ROLES(roles);
		this.SET_NAME(name);
		this.SET_AVATAR(avatar);
		this.SET_INTRODUCTION(introduction);
		this.SET_EMAIL(email);
	}

	/** document hooks */
	@Action
	public async changeRoles(role: string): Promise<any> {
		// Dynamically modify permissions
		const token: any = `${role}-token`;

		// this.SET_TOKEN(token);
		// setToken(token);
		await this.getUserInfo();
		resetRouter();
		// Generate dynamic accessible routes based on roles
		permissionModule.generateRoutes(this.roles);
		// Add generated routes
		router.addRoutes(permissionModule.dynamicRoutes);
		// Reset visited views and cached views
		tagsViewModule.delAllViews();
	}

	/** document hooks */
	@Action
	public async logOut(): Promise<any> {
		if (this.token === '') {
			throw Error('logOut: token is undefined!');
		}

		await serviceUsers.logout();
		removeToken();
		resetRouter();

		// Reset visited views and cached views
		tagsViewModule.delAllViews();
		// this.SET_TOKEN('');
		this.SET_ROLES([]);
	}

	/** 工作流数据 */
	public workflowList: Array<IWorkflowData> = [];

	/** mutation 设置工作流 */
	@Mutation
	private SET_WORKFLOW(payload: Array<IWorkflowData>): any {
		this.workflowList = payload;
	}

	/** action 保存工作流 */
	@Action
	public saveWorkflow(payload: Array<IWorkflowData>): any {
		this.SET_WORKFLOW(payload);
	}
}

/** 用户基础信息 */
export const userModule: any = getModule(User);

/**
 * 用户数据结构
 *
 * @export
 * @interface IUserData
 */
export interface IUserData {
	avatar?: string;
	bgId?: number;
	bgName?: string;
	deptId?: string;
	ccId?: number;
	ccName?: string;
	groupId?: number;
	groupName?: string;
	deptName?: string;
	fullName?: string;
	id?: number;
	loginAddress?: any;
	loginTime?: number;
	nickName: string;
	ouId?: number;
	ouName?: string;
	permissions?: Array<IUserPermission>;
	roles?: Array<IUserRoles>;
	staffTypeId?: string;
	staffTypeName?: string;
	currentRole?: IUserRoles;
}

/**
 * 用户权限数据
 *
 * @export
 * @interface IUserPermission
 */
export interface IUserPermission {
	code: string;
	permission: string;
	type: any;
}

export interface IUserRoles {
	code?: string;
	name?: string;
	id?: string;
}
